// extracted by mini-css-extract-plugin
export var currencyInput = "_k0-1";
export var currencySymbol = "_k0-0";